<template>
  <div class="container">
    <header class="page-header">
      <!-- <h1 class="page-title">RFQ</h1> -->
      <ol class="breadcrumb page-breadcrumb">
        <li>
          <router-link :to="{ name: 'home'}">Home</router-link>
        </li>
        <li>
          <router-link
            :to="{ name: 'product', params: { id: productInfo.Id }}"
          >{{productInfo.ProductName}}</router-link>
        </li>
        <li>
          <!-- <a href="#">{{productDetails.Name}}</a> -->
          RFQ - Product
        </li>
      </ol>
    </header>
    <div class="row">
      <div class="col-md-9">
        <div class="row" data-gutter="15">
          <div class="col-md-12">
            <div class="product product-left">
              <div class="row">
                <div class="col-md-12 widget-title-lg">
                  <h5 class="product-caption-title-search">RFQ</h5>
                </div>
              </div>
              <div class="row">
                <div class="col-md-2">
                  <img
                    v-bind:src="productInfo.CompanyLogo"
                    alt="Image Alternative text"
                    title="Image Title"
                    class="product-page-product-wrap"
                    width="70px"
                    height="70px"
                  />
                </div>
                <div class="col-md-9">
                  <h5 class="product-caption-title-search text-primary">{{productInfo.CompanyName}}</h5>
                  <span class="product-caption-price-search">{{productInfo.CompanyLocation}}</span>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12 form-group"></div>
              </div>
              <div class="row">
                <div class="col-md-12 form-group"></div>
              </div>
              <div class="row">
                <!-- <div class="col-md-12 bg-light form-group pt-3">
                  <h5 class="product-caption-title-search-co text-primary">Item RFQ</h5>
                </div>-->

                <div class="col-md-12" style="border-bottom: 1px solid grey">
                  <h5 class="product-caption-title-search text-primary">RFQ Item</h5>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12 form-group"></div>
              </div>
              <div class="row">
                <div class="col-md-3">
                  <!-- <a
                    v-bind:class="{ zoomThumbActive:true}"
                    href="javascript:void(0)"
                    v-bind:data-rel="buildImageRel(productInfo.ProductImage)"
                  >-->
                  <img
                    v-bind:src="productInfo.ProductImage"
                    alt="Image Alternative text"
                    title="Image Title"
                    class="product-page-product-wrap"
                    width="150px"
                    height="150px"
                  />
                  <!-- </a> -->
                </div>
                <div class="col-md-9 no-gutters">
                  <div class="col-md-8">
                    <h6
                      class="product-caption-title-search text-primary"
                    >{{productInfo.ProductName}}</h6>
                    <span
                      class="product-caption-price-search"
                    >{{productInfo.ProductShortDescription}}</span>
                  </div>
                  <div class="col-md-4">
                    Quantity
                    <!-- <input type="text" class="form-control" /> -->
                    <input v-model="quantity" class="form-control" type="number" min="0" />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12 form-group"></div>
              </div>

              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="comment">Message:</label>
                    <textarea class="form-control" rows="5" v-model="message"></textarea>
                  </div>
                  <div id="btn-container">
                    <div class="float-left">
                      <button
                        type="button"
                        class="btn btn-primary"
                        @click.stop="onSubmit"
                      >Send RFQ Now</button>
                    </div>

                    <div class="btn btn-primary" id="btn-upload" @click="openFileInput">
                      <i class="fa fa-upload mr-1" aria-hidden="true"></i>Upload File (.pdf)
                    </div>
                    <div style="width: 0px; overflow: hidden;">
                      <input type="file" ref="inputFile" class="form-control" 
                        @change="onFileSelect" accept="application/pdf"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <span class="mr-1">{{displayFileName}} </span>
              <span v-if="attachment !== null" @click="cancelUpload">
                <i class="fa fa-times-circle" aria-hidden="true" style="cursor:pointer;" title="Cancel Upload"></i>
              </span>
              <div class="row">
                <div class="col-md-12 form-group"></div>
              </div>
              <div class="row" v-if="error != ''">
                <div class="col-md-12 form-group">
                  <div class="alert alert-danger">
                    <label>{{error}}</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <!-- <aside class="category-filters">
					<div class="category-filters-section-tender">
						<h3 class="widget-title-sm-tender">Latest RFQ</h3>
					</div>
					<div class="category-filters-section-tenderdetail">
						<h3 style="color: rgb(2, 2, 2); font-size: 17px;"><a href="">Kementerian Kewangan Malaysia</a></h3>
						<div>
							<p style="color: rgb(2, 2, 2); font-size: 13px;">Pelupusan Komponen Aset Tak Alih Kerajaan</p>
							<p></p>
							<p style="color: rgb(2, 2, 2); font-size: 13px;">October 1, 2019</p>
						</div>
					</div>
					<div class="category-filters-section-tenderdetail">
						<h3 style="color: rgb(2, 2, 2); font-size: 17px;"><a href="">Telekom Malaysia Berhad</a></h3>
						<div>
							<p style="color: rgb(2, 2, 2); font-size: 13px;"> INTEGRATED FACILITES MANAGEMENT (IFM) AT MENARA TM, TM ANNEXE 1&amp;2, MENARA TM SEMARAK AND WISMA TM TAMAN DESA FOR TELEKOM MALAYSIA BERHAD (“TM”)</p>
							<p></p>
							<p style="color: rgb(2, 2, 2); font-size: 13px;">October 19, 2019</p>
						</div>
					</div>
        </aside>-->
      </div>
    </div>
    <div class="gap gap-small"></div>
    <div v-if="showLoader" class="modal" id="loading">
      <div class="modal-content" id="loading-content">
        <span class="loader"><span class="loader-inner"></span></span>
        <label>Please wait a second!</label>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Vue from "vue";
import VueSimpleAlert from "vue-simple-alert";
Vue.use(VueSimpleAlert);

export default {
  components: {
    //
  },
  data() {
    return {
      authKey: null,
      quantity: 0,
      message: "",
      error: "",
      user: JSON.parse(localStorage.getItem("user")),
      showLoader: false,
      attachment: null,
      attachmentUrl: '',
      displayFileName: '',
      fileName: '',
      typeRfq: 'product',
    };
  },
  created() {
    //console.log("MASUK CREATE rfq ::::::::::::", this.$route.params.id);
    this.$store
      .dispatch("products/fetchProductDetails", {
        productId: this.$route.params.id
      })
      .then(() => {
        var evt = new CustomEvent("jqzoom-initialize", {});
        window.dispatchEvent(evt);
      });
  },
  computed: {
    ...mapState({
      product: state => state.products.productDetails
    }),
    firstImage() {
      var defaultImages = this.product.productImage.filter(
        image => image.IsDefault
      );
      if (defaultImages.length > 0) {
        return defaultImages[0].ImageURL;
      }

      if (this.product.productImage.length > 0) {
        return this.product.productImage[0].ImageURL;
      }

      return "";
    },
    description() {
      if (this.product.description.length > 0) {
        return this.product.description[0];
      }

      return {};
    },
    productDetails() {
      if (this.product.productDetail.length > 0) {
        //console.log('this.product.productDetail :::::::::::::: ', this.product.productDetail[0]);
        //console.log('this.product.productInfo :::::::::::::: ', this.productInfo);
        return this.product.productDetail[0];
      }
      return {};
    },
    getUser() {
      //   console.log(
      //     "XlocalStorage USER :::::::::: ",
      //     localStorage.getItem("user").id
      //   );
      return localStorage.getItem("user") !== null && localStorage.getItem("user") !== 'null' ? true : false;
    },
    companyProfile() {
      if (this.product.companyProfile.length > 0) {
        return this.product.companyProfile[0];
      }
      return {};
    },
    productInfo() {
      //console.log('pInfo 111 ::::::::::::: ', this.productDetails);
      //console.log('pInfo 222 ::::::::::::: ', this.companyProfile);
      let pInfo = {
        Id: this.productDetails.Id,
        CompanyName: this.productDetails.CompanyName,
        CompanyId: this.productDetails.CompanyId,
        CompanyLogo: this.companyProfile.LogoUrl,
        CompanyLocation: this.productDetails.Location,
        ProductImage: this.firstImage,
        ProductName: this.productDetails.Name,
        ProductShortDescription: this.productDetails.ShortDescription
      };
      //console.log("pInfo ::::::::::::: ", pInfo);
      return pInfo;
    }
  },
  methods: {
    buildImageRel(image) {
      //console.log('buildImageRel ::::::::::::::::::::: ');
      return (
        "{gallery:'gal-1', smallimage:'" +
        image +
        "', largeimage:'" +
        image +
        "'}"
      );
    },
    async onSubmit() {
      if (this.quantity == "" || this.quantity == null) {
        this.error = "Quantity is empty";
        return;
      }
      else if (this.quantity < 0) {
        this.error = "Quantity cannot be negative";
        return;
      } else if (this.message == "" || this.message == null) {
        this.error = "Message is empty";
        return;
      } else {
        this.error = "";
      }

      const confirmed = await this.$confirm("", "Are you sure to submit your RFQ?");
      //console.log(r);
      if (confirmed) {
        this.showLoader = true;
          
        if (this.attachment != null) {
          this.fileName = this.displayFileName.split('.')[0];
          const result = await this.$store.dispatch("products/addAttachmentRfq", { attachment: this.attachment, typeRfq: this.typeRfq });
          // console.log('check result :::: ', result);
          // console.log('check filename :::: ', this.fileName);
          this.attachmentUrl = result;
        }

        try {
          await this.$store.dispatch("products/addRfq", {
            categoryTypeId: 1,
            title: "RFQ : " + this.productDetails.Name,
            quantity: this.quantity,
            toTenantId: this.productDetails.CompanyId,
            rfqBody: this.message,
            fromUserId: this.user.id,
            productName: this.productDetails.Name,
            productServiceId: this.productDetails.Id,
            productUomId: 1,
            attachmentUrl: this.attachmentUrl,
            fileName: this.fileName,
          });
          this.showLoader = false;
        } catch (error) {
          console.error(error);
          this.showLoader = false;
        }
      }
      

      this.$alert(
        "To folow up, please check in 'Qoute Me' module in Dashboard",
        "RFQ sucessfully send",
        "success"
      ).then(() => {
        this.$router.push({
          name: "product",
          params: { id: this.productDetails.Id }
        });
      });
    },

    openFileInput() {
      this.$refs.inputFile.value = '';
      this.$refs.inputFile.click();
    },

    onFileSelect(event) {
      if (event.target.files.length > 0) {
        const file = event.target.files[0];
        this.attachment = file;
        this.displayFileName = file.name;
      }
    },

    cancelUpload() {
      this.$refs.inputFile.value = '';
      this.attachment = null;
      this.displayFileName = '';
    },
  }
};
</script>
<style>
#btn-container {
  display: flex;
  gap: 10px;
}

#btn-upload {
  height: 80%;
}
</style>
